import React from "react"
import { Container, Image, Text } from "@mantine/core"
import { useStyles } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/FavoritesRecentsTabs.styles"
import { Button, Icon, UnstyledButton } from "@/components"
import { EmptyTab } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/EmptyTab"
import { RecentsTabProps } from "@/components/TopNavigation/types"

import { handleSegueSearch } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/helpers"

export const RecentsTab = (props: RecentsTabProps) => {
    const { classes } = useStyles()

    const {
        closeSearchPopdown,
        recents,
        favoriteUserAction,
        archiveUserAction,
        setSearchTerm,
        segueToSearch,
        segueToProfile,
    } = props

    return (
        <Container className={classes.container}>
            {recents.length > 0 ? (
                <>
                    {recents.map((recent) => {
                        const dataType: any = DjangIO.app.models.QuorumDataType.by_value(recent.data_type)
                        const displayImage = recent.person__image_url || recent.supporter__image_url

                        return (
                            <div className={classes.itemContainer} key={recent.id}>
                                <UnstyledButton
                                    className={classes.button}
                                    onClick={() =>
                                        handleSegueSearch(
                                            recent,
                                            dataType,
                                            setSearchTerm,
                                            segueToProfile,
                                            segueToSearch,
                                            closeSearchPopdown,
                                        )
                                    }
                                >
                                    <div className={classes.iconContainer}>
                                        {displayImage === null ? (
                                            <Icon
                                                icon={dataType.fa5_icon}
                                                iconFamily={dataType.fa5_icon_family || "fas"}
                                            />
                                        ) : (
                                            <Image height="2rem" radius="50%" src={displayImage} />
                                        )}
                                    </div>

                                    <div className={classes.searchText}>
                                        <Text
                                            onClick={() =>
                                                handleSegueSearch(
                                                    recent,
                                                    dataType,
                                                    setSearchTerm,
                                                    segueToProfile,
                                                    segueToSearch,
                                                    closeSearchPopdown,
                                                )
                                            }
                                            className={classes.text}
                                        >
                                            {recent.humanized_text}
                                        </Text>
                                    </div>

                                    <div className={classes.dataTypeText}>
                                        <Text>{dataType.singular}</Text>
                                    </div>
                                </UnstyledButton>

                                <div className={classes.actionsContainer}>
                                    <Button
                                        className={classes.actionIcon}
                                        variant="transparent"
                                        aria-label="Favorite"
                                        onClick={() => {
                                            favoriteUserAction(recent)
                                        }}
                                    >
                                        <Icon icon="star" className={classes.starIcon} />
                                    </Button>
                                    <Button
                                        className={classes.actionIcon}
                                        variant="transparent"
                                        aria-label="Archive"
                                        onClick={() => {
                                            archiveUserAction(recent)
                                        }}
                                    >
                                        <Icon icon="times" className={classes.timesIcon} />
                                    </Button>
                                </div>
                            </div>
                        )
                    })}
                    {recents.length > 7 && (
                        <div className={classes.noMoreResultsText}>
                            <Icon icon="exclamation-circle" />
                            No more results
                        </div>
                    )}
                </>
            ) : (
                <EmptyTab
                    icon="search"
                    title="Search history empty"
                    description="Start searching and visiting datasets profiles to add data here."
                />
            )}
        </Container>
    )
}
